const ACTIONS_WITH_MULTI_RESULTS = [
  'assign_operators', 'delete_assigned_operators',
  'add_tags', 'remove_tags',
  'add_to_folder', 'delete_from_folder'
]

export const isDisabledButton = (params = {}) => {
  const { selectedItems, selectedAction, selectedResultAction, resultActionOptions, messageAction, brandsDelegations } = params

  if (!Array.isArray(selectedItems) || !selectedItems.length) return true
  if (!selectedAction?.value) return true

  if (ACTIONS_WITH_MULTI_RESULTS.includes(selectedAction?.value)
    && (!resultActionOptions[selectedAction?.value]?.length || !selectedResultAction?.length)
  ) return true

  if (['change_status'].includes(selectedAction?.value) && !selectedResultAction?.value) return true
  if (selectedAction?.withMessage && !messageAction?.content) return true
  if (selectedAction?.value === 'change_centers' && !brandsDelegations.delegations?.length) return true

  return false
}